import classNames from 'classnames';

import s from './RichText.sss';

type RichTextProps = React.HTMLProps<HTMLDivElement>;

export const RichText: React.FC<RichTextProps> = ({ className, ...props }) => (
  <div className={classNames(s.root, className)} {...props} />
);
